import styled from "styled-components";
import { FlexContainer } from "../../AdAssistant.styled";

export const EditionPreviewWrapper = styled(FlexContainer)`
  gap: 20px;

  @media screen and (min-width: 1920px) {
    gap: 30px;
  }
`;
